<!-- @veltra/icons generated sha256:90e899028fd99a97 gen:8 source:src/svg/colorful/word.svg -->
<script setup lang="ts">
defineOptions({ name: 'Word' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <defs>
      <clipPath id="a"><rect width="16" height="16" rx="0" /></clipPath>
    </defs>
    <g clip-path="url(#a)">
      <path
        fill="#53b7f4"
        d="M10.293 1.006H4.21c-1.22 0-2.208.989-2.208 2.208v9.578c0 1.22.988 2.208 2.208 2.208h7.586c1.22 0 2.208-.989 2.208-2.208V4.717a1.87 1.87 0 0 0-.55-1.326L11.62 1.555a1.88 1.88 0 0 0-1.326-.549"
      />
      <path
        fill="#29a3d3"
        d="M10.123 5.635a.375.375 0 0 0-.375.375v3.535L8.273 8.088a.375.375 0 0 0-.526-.001L6.259 9.55V6a.375.375 0 0 0-.75 0v4.444a.375.375 0 0 0 .637.267l1.863-1.83 1.85 1.83a.375.375 0 0 0 .639-.267V6.01a.375.375 0 0 0-.375-.375m3.332-2.244L11.62 1.555a1.9 1.9 0 0 0-.965-.514v2.06c0 .655.53 1.185 1.185 1.185h2.115a1.9 1.9 0 0 0-.499-.895"
      />
      <path
        fill="#fff"
        d="M10.123 10.631a.38.38 0 0 1-.264-.108l-1.85-1.83-1.863 1.83a.375.375 0 0 1-.637-.267V5.812a.375.375 0 0 1 .75 0v3.55L7.747 7.9a.375.375 0 0 1 .526 0l1.475 1.458V5.823a.375.375 0 0 1 .75 0v4.433a.375.375 0 0 1-.375.375"
      />
    </g>
  </svg>
</template>
